import { t } from "@lingui/macro"

export enum POLL_STATUS {
    OPEN = "open",
    CLOSED = "closed",
    SCHEDULED = "scheduled",
    DRAFT = "draft",
    DELETED = "deleted",
}

export const POLL_STATUS_OPTIONS = {
    [POLL_STATUS.OPEN]: {
        get name() {
            return t`polls.status-open`
        },
    },
    [POLL_STATUS.CLOSED]: {
        get name() {
            return t`polls.status-closed`
        },
    },
    [POLL_STATUS.SCHEDULED]: {
        get name() {
            return t`polls.status-scheduled`
        },
    },
    [POLL_STATUS.DRAFT]: {
        get name() {
            return t`polls.status-draft`
        },
    },
    [POLL_STATUS.DELETED]: {
        get name() {
            return t`polls.status-deleted`
        },
    },
}
